<template>
	<div id="app">
		<Navbar />
		<router-view/>
		<Footer />
	</div>
</template>

<script>
	import Navbar from '@/components/Navbar.vue';
	import Footer from '@/components/Footer.vue';
	
	export default {
		name: 'App',
		components: {
			Navbar,
			Footer
		},
		metaInfo: {
			title: 'Instalacje CO Warszawa - Naprawa, Przeglądy, Serwis Brotje, Valiant',
			titleTemplate: null
		}
	}
</script>